module.exports = __webpack_public_path__ + "static/media/charactor_royal_guard.32a7ca93.png";